import Vuetify from 'vuetify';
import Vue from "vue";
import vuetifyConfig from './vuetify.config';

import {
    VAlert,
    VApp,
    VAutocomplete,
    VBtn,
    VBtnToggle,
    VCard,
    VCol,
    VContainer,
    VDialog,
    VDivider,
    VForm,
    VIcon,
    VLayout,
    VList,
    VListItem,
    VListItemTitle,
    VMenu,
    VProgressCircular,
    VRow,
    VSnackbar,
    VSwitch,
    VTextarea,
    VTextField,
    VTooltip,
} from "vuetify/lib/components";
// todo: change all above import to the next line import so we won't import all vuetify component
// import VAlert from 'vuetify/lib/components/VAlert'\

Vue.use(Vuetify, {
    components: {
        VAlert,
        VApp,
        VAutocomplete,
        VBtn,
        VBtnToggle,
        VCard,
        VCol,
        VContainer,
        VDialog,
        VDivider,
        VForm,
        VIcon,
        VLayout,
        VList,
        VListItem,
        VListItemTitle,
        VMenu,
        VProgressCircular,
        VRow,
        VSnackbar,
        VSwitch,
        VTextarea,
        VTextField,
        VTooltip,
    }
});

const DesignSystem = ({theme = {}, options = {}} = {}) => {
    const ds = {...options};
    // Make the options available to all the components
    Vue.prototype.$ds = ds;
    Vue.prototype.$log = Vue.prototype.$log || console.log;

    const vuetifyConfigOverride = Object.assign({}, vuetifyConfig, theme);
    return new Vuetify(vuetifyConfigOverride)
}

export default DesignSystem;